import { HStack, Text } from '@chakra-ui/react'
import { useContext } from 'react'
import { useDropzoneStyles } from '~/components/shared/componentStyles/Dropzone.style'

import { Context } from './Context'
import { composeErrorText } from './utils'

export default function ContentError() {
  const {
    currentVariant,
    fileRejections,
    dropzoneState: { isDragActive, isDragAccept },
    props: {
      dragErrorText = 'This file is not supported',
      fileTypeErrorText = 'This file type is not supported',
      fileSizeErrorText,
      multiErrorText = 'Some files you selected are either too large, or their types are not supported.',
      maxFileSize,
    },
  } = useContext(Context)

  const styles = useDropzoneStyles({
    variant: currentVariant,
  })

  const errorText = composeErrorText({
    copy: {
      dragErrorText,
      fileSizeErrorText,
      fileTypeErrorText,
      multiErrorText,
    },
    fileRejections,
    isDragAccept,
    isDragActive,
    maxFileSize,
  })

  return (
    <HStack>
      <Text css={styles.text}>{errorText}</Text>
    </HStack>
  )
}
